import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileSmallTextControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setTextsHeight(element);
    }

}

const mobileSmallTextControlView = new MobileSmallTextControlView();
export default mobileSmallTextControlView;